import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";
import { ProviderTag } from "../types";

export async function fetchProviderTags(spaceId: string): Promise<ProviderTag[]> {
  const { data, error } = await apiClient
    .from('provider_tags')
    .select('*')
    .eq('space_id', spaceId)
    .order('name', { ascending: true });

  if (error) {
    throw error;
  }

  return data ?? [];
}

export function useGetProviderTags() {
  const { currentSpace } = useSpace();
  const spaceId = currentSpace?.id ?? '';

  return useQuery({
    queryKey: keys.getProviderTags(spaceId),
    queryFn: () => fetchProviderTags(spaceId),
    enabled: !!spaceId,
  });
}

